__turbopack_context__.v({
  "headerRow": "MaatregelenRowTemplate-module___sbdAa__headerRow",
  "measureAnswersDetailRow": "MaatregelenRowTemplate-module___sbdAa__measureAnswersDetailRow",
  "measureAnswersOverviewRow": "MaatregelenRowTemplate-module___sbdAa__measureAnswersOverviewRow",
  "rowContainer": "MaatregelenRowTemplate-module___sbdAa__rowContainer",
});
